import { mapState } from 'vuex'
import organizationApi from '@/services/organizationApi'

export default {
  data: () => ({
    mfaEnabled: null,
    isRequired2faFromOrganization: null,
    showRequired2faModal: false,
    showPresent2faFeatModal: false,
  }),
  computed: {
    ...mapState({
      organization: (state) => state.user.organization,
      userData: (state) => state.user.userAllInfo,
    }),
  },
  created() {
    this.$root.$on('check2faSettings', () => {
      this.checkMfa()
    })
  },
  beforeDestroy() {
    this.$root.$off('check2faSettings')
  },
  methods: {
    async checkMfa() {
      await this.handleEnabledMfa()
      if (!this.mfaEnabled) {
        await this.handleRequiredMfa()
        this.handle2faModals()
      }
    },
    async handleRequiredMfa() {
      try {
        const { data: organizationData } =
          await organizationApi.getOrganization()
        this.isRequired2faFromOrganization = organizationData.require_mfa
      } catch (error) {
        this.isRequired2faFromOrganization = false
        console.log(error)
      }
    },
    async handleEnabledMfa() {
      try {
        const targetKey = Object.keys(localStorage).find((key) =>
          key.includes('LastAuthUser')
        )
        const userId = localStorage.getItem(targetKey)
        const { data: userData } = await organizationApi.getUserById(userId)

        this.mfaEnabled = userData.mfa_enabled
      } catch (error) {
        this.mfaEnabled = false
        console.log(error)
      }
    },
    handle2faModals() {
      if (this.isRequired2faFromOrganization && !this.mfaEnabled) {
        this.$root.$emit('isRequired2faFromOrganization', true)
        this.$root.$emit('openRequired2faModal')
      }
      if (!this.isRequired2faFromOrganization && !this.mfaEnabled) {
        const creationDate = this.userData.created_at
        const lastDismissed = localStorage.getItem('2FA_modal_dismissed')
        if (this.shouldShow2faFeatModal(creationDate, lastDismissed))
          this.$root.$emit('openPresent2faFeatModal')
      }
    },
    shouldShow2faFeatModal(creationDate, lastDismissed) {
      const createdAt = new Date(creationDate)
      const now = new Date()

      // ---------- 1) janela de 24-48 h depois da criação ----------
      if (!lastDismissed) {
        const oneDay = new Date(createdAt.getTime() + 1 * 24 * 60 * 60 * 1000)
        const twoDays = new Date(createdAt.getTime() + 2 * 24 * 60 * 60 * 1000)
        if (now >= oneDay && now < twoDays) return true
      }

      // ---------- 2) 6 meses depois do último fechamento (ou da criação) ----------
      const base = lastDismissed ? new Date(lastDismissed) : createdAt
      const sixMonthsLater = new Date(base)
      sixMonthsLater.setMonth(base.getMonth() + 6)

      return now >= sixMonthsLater
    },
  },
}
